import React, { Component } from 'react';
import { Toast, WhiteSpace, List, Picker } from 'antd-mobile';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { createBrowserHistory } from "history";

import './style.less';
import { Button } from 'antd';
const posts = [
    { value: 1, text: '330200', label: '宁波' }, { value: 2, text: '330100', label: '杭州' }, { value: 3, text: '330300', label: '温州' }
];
const history = createBrowserHistory();
export default class QueryReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mcno: this.props.match.params.mcno,
            hospitallist: [],
            mcid: 0,
            cityid: 0,
            citycode: '',
            tjbh: '',
            ckmm: '',
            hospitalname: '',
            reporttel: '',
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState(
            { [name]: value },
            () => {
            }
        );
    }
    componentDidMount() {
        let mc = posts.find((value) => value.text === window.globalvariable.getStore('cityid'));
        if (!!mc) {
            let cm = [];
            cm.push(mc.value)
            this.setState(
                { cityid: cm, citycode: mc.text },
                () => {
                    this.GetReportTreelist();
                }
            );
        }
    }
    GetReportTreelist = () => {
        if (parseInt(this.props.match.params.mcno) === 0) {
            services.GetReportTreelist(this.state.citycode, '正在查询，请稍后').then(hospital => {
                if (hospital.status === 0) {
                    let hospitalData = [];
                    hospital.result.forEach(element => {
                        hospitalData.push({ value: element.mcid, label: element.mcname, text: element.mcno, tel: element.reporttel });
                    });
                    if (parseInt(this.state.mcno) !== 0) {
                        let mc = hospitalData.find((value) => value.text === this.state.mcno);
                        if (!!mc) {
                            let cbox = [];
                            cbox.push(mc.value);
                            this.setState({ mcid: cbox, hospitalname: mc.label, reporttel: mc.tel });
                        }
                    }
                    this.setState({ hospitallist: hospitalData });
                } else {
                    Toast.offline(hospital.message);
                }
            })
        } else {
            services.GetHospitalDetails(this.props.match.params.mcno, '正在查询，请稍后').then(hospital => {
                if (hospital.status === 0) {
                    this.setState({ mcid:hospital.result.mcid, hospitalname: hospital.result.mcname, reporttel: hospital.result.reporttel });
                }else
                {
                    Toast.offline(hospital.message,2);
                }
            })

        }
    }
    onHospital = (e) => {
        let mc = this.state.hospitallist.find((value) => value.value === e[0]);
        this.setState({ mcid: e, mcno: mc.text, hospitalname: mc.label, reporttel: mc.tel });
    }
    onCity = (e) => {
        let mc = posts.find((value) => value.value === e[0]);
        this.setState(
            { cityid: e, citycode: mc.text, mcid: 0, hospitalData: [] },
            () => {
                this.GetReportTreelist();
            }
        );
    }
    queryReport = () => {
     
        if (parseInt(this.state.mcno) === 0) {
            Toast.offline('请选择您体检的医院', 2);
            return false;
        }
        if (!!this.state.tjbh === false) {
            Toast.offline('请输入您的报告编号', 2);
            return false;
        }
        if (!!this.state.ckmm === false) {
            Toast.offline('请输入正确的报告密码', 2);
            return false;
        }
        let params = { tjbh: this.state.tjbh, password: this.state.ckmm, mcno: this.state.mcno };
        services.GetReportD(params, '正在查询，请稍后').then(data => {
            if (data.code === 1) {
                localStorage.setItem('REPORT-INFO', JSON.stringify(data));
                history.push(`/members/report/reportdetail`);
                history.go();
            } else {
                Toast.offline(data.msg);
            }
        });

    }
    render() {
        const { hospitallist } = this.state;
        return <div className="report">
            <CommonlyHeadMembers barname="报告查询" />
            <div className="addreportbox addreportbox2" >
                <List renderHeader={() => '*所有项目必填，请仔细输入'}>
                    {
                        parseInt(this.props.match.params.mcno) === 0 ?
                            <Picker
                                data={posts}
                                value={this.state.cityid}
                                cols={1}
                                onChange={this.onCity}
                                extra="请选择体检城市"
                            ><List.Item arrow="horizontal">体检城市：</List.Item>
                            </Picker>
                            : ''
                    }
                    {
                        parseInt(this.props.match.params.mcno) === 0 ?
                            <Picker
                                data={hospitallist}
                                value={this.state.mcid}
                                cols={1}
                                onChange={this.onHospital}
                                extra="请选择体检中心"

                            ><List.Item arrow="horizontal">体检中心：</List.Item>
                            </Picker>
                            : <List.Item >
                              <span className="name">体检中心：</span><input type="text" disabled  value={this.state.hospitalname} />
                            </List.Item>
                           
                    }
                    <List.Item>
                        <span className="name">体检编号：</span><input type="text" placeholder="由体检中心提供" name="tjbh" onChange={this.handleInputChange} />
                    </List.Item>
                    <List.Item>
                        <span className="name">查询密码：</span><input type="password" name="ckmm" placeholder="请输入体检报告查询密码" onChange={this.handleInputChange} />
                    </List.Item>

                </List>
                <Button className="submitBut" onClick={this.queryReport} >查询报告</Button>
                <WhiteSpace />
                <div className="transfertips">
                    <div className="b">体检报告查询说明：</div>
                    <div>1、体检结束时，在体检中心领取您的体检编号和查看密码。</div>
                    <div>2、如忘记编号或密码，请致电体检中心索取。<span >
                    {!!this.state.reporttel ? '报告咨询电话:': ''}
                    {!!this.state.reporttel ? <a href={'tel:'+this.state.reporttel}> {this.state.reporttel}</a>: ''}
                   </span></div>
                    <div>3、一般在体检结束后，4-7个工作日方可查询。</div>
                    <div>4、如还有疑问，请拨打客服电话：<a href={'tel:0574-89119527'}>0574-89119527</a></div>
                </div>
            </div>
        </div>;
    }
}